<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >账号注销
    </navigation>
    <div class="content">
      <div class="separator"></div>
      <img src="./images/icon_auth@2x.png">
      <div class="title">为了保障您的账号安全</div>
      <div class="desc">注销前需进行身份验证，避免他人恶意注销</div>
      <div class="begin-button" @click="beginAuth">开启验证</div>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    beginAuth () {
      this.$router.push({
        path: '/mine/signout/auth'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  width: 750px;
  height: 100%;
  background: #fff;
  .content {
    text-align: center;
    .separator {
      width: 100%;
      height: 20px;
      background: #fafafa;
    }
    img {
      width: 146px;
      height: 170px;
      margin-top: 140px;
    }
    .title {
      font-size: 42px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 59px;
    }
    .desc {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
      margin-top: 16px;
    }
    .begin-button {
      width: 320px;
      height: 80px;
      border-radius: 40px;
      border: 2px solid #FF4633;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FF4633;
      line-height: 80px;
      margin: 72px auto;
    }
  }
}
</style>